import axios from "axios";
let BASE_URL = process.env.NODE_ENV === "production" ? process.env.VUE_APP_API_URL : "";

export default {
  state: {
   eventListing: [],
   eventRegistrations: [],
   eventAttendance: [],
   totalPeople:[]
  },
  getters: {
    getEventListing: (state) => state.eventListing,
    getEventRegistrations: (state) => state.eventRegistrations,
    getEventAttendance: (state) => state.eventAttendance,
    getTotalpeople: (state) => state.totalPeople,
  },
  actions: {
    fetchEvents({commit}){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/physical-events/events`).then((response) => {
            commit("setEventListing",response.data.data)
            resolve(response.data.data)
        }).catch(error => {
            reject(error.response.data)
        })
      })
    },
    fetchEventRegistrations({commit}, event_id){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/physical-events/registrations/${event_id}`).then((response) => {
            const totalPeople = response.data.data.reduce((sum, item) => {
              return sum + Number(item.no_of_people || 0)
            }, 0)
            commit("setEventRegistrations",response.data.data)
            commit("setEventTotalPeople",totalPeople)
            resolve(response.data.data)
        }).catch(error => {
            reject(error.response.data)
        })
      })
    },
    fetchEventAttendance({commit}, event_id){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/physical-events/attendance/${event_id}`).then((response) => {
            commit("setEventAttendance",response.data.data)
            resolve(response.data.data)
        }).catch(error => {
            reject(error.response.data)
        })
      })
    },
    createEvent({commit}, payload){
      return new Promise((resolve,reject) => {
        axios.post(`${BASE_URL}/physical-events/create`,payload).then((response) => {
            commit("setEventListing",response.data.data)
            resolve(response.data.data)
        }).catch(error => {
            reject(error.response.data)
        })
      })
    },
    addEventData({}, payload){
      return new Promise((resolve,reject) => {
        axios.put(`${BASE_URL}/physical-events/data`,payload).then((response) => {
            resolve(response.data.data)
        }).catch(error => {
            reject(error.response.data)
        })
      })
    },
    fetchEventData({}, uri){
      return new Promise((resolve,reject) => {
        axios.get(`${BASE_URL}/physical-events/data/${uri}`).then((response) => {
            resolve(response.data.data)
        }).catch(error => {
            reject(error.response.data)
        })
      })
    },
  },
   mutations: {
    setEventListing: (state, eventListing) => (state.eventListing = eventListing),
    setEventRegistrations: (state, eventRegistrations) => (state.eventRegistrations = eventRegistrations),
    setEventAttendance: (state, eventAttendance) => (state.eventAttendance = eventAttendance),
    setEventTotalPeople: (state, totalPeople) => (state.totalPeople = totalPeople)
   }
}